// src/config/projectFormMapping.js
import { setTowerType } from "../redux/slices/towerSlice";

export const PROJECT_FORM_MAPPING = {
  generalInfo: [
    {
      fieldName: "dealId",
      componentId: "generalInfo",
      questionId: "dealId",
    },
    {
      fieldName: "company_name",
      componentId: "companyInfo",
      questionId: "company_name",
    },
    {
      fieldName: "serialNumber",
      componentId: "generalInfo",
      questionId: "serialNumber",
    },
    {
      fieldName: "status",
      componentId: "generalInfo",
      questionId: "status",
      options: [
        { value: "Pending", label: "Pending" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
        { value: "In Progress", label: "In Progress" },
        { value: "Resubmit", label: "Resubmit" },
      ],
    },
    {
      fieldName: "statusReason",
      componentId: "generalInfo",
      questionId: "statusReason",
    },
    {
      fieldName: "customerTowerDesignation",
      componentId: "generalInfo",
      questionId: "customer_tower_designation",
    },
    {
      fieldName: "tower",
      componentId: "tower",
      questionId: "type",
      onChange: (value, dispatch) => {
        dispatch(setTowerType(value));
      },
    },
    {
      fieldName: "subtype",
      componentId: "tower",
      questionId: "subtype",
    },
    {
      fieldName: "submitter",
      componentId: "generalInfo",
      questionId: "submitter",
    },
    {
      fieldName: "submitter_email",
      componentId: "generalInfo",
      questionId: "submitter_email",
    },
    {
      fieldName: "manufacturer",
      componentId: "towerManufacturer",
      questionId: "tower_manufacturer",
    },
    {
      fieldName: "model",
      componentId: "generalInfo",
      questionId: "model",
    },
    {
      fieldName: "state",
      componentId: "generalInfo",
      questionId: "state",
    },
    {
      fieldName: "city",
      componentId: "generalInfo",
      questionId: "city",
    },
    {
      fieldName: "street",
      componentId: "generalInfo",
      questionId: "street",
    },
    {
      fieldName: "zip",
      componentId: "generalInfo",
      questionId: "zip",
    },
    {
      fieldName: "numberOfCells",
      componentId: "generalInfo",
      questionId: "numberOfCells",
    },
    {
      fieldName: "cellLength",
      componentId: "generalInfo",
      questionId: "cellLength",
    },
    {
      fieldName: "cellWidth",
      componentId: "generalInfo",
      questionId: "cellWidth",
    },
    {
      fieldName: "cellHeight",
      componentId: "generalInfo",
      questionId: "cellHeight",
    },
    {
      fieldName: "cwb_grade_to_curb_height",
      componentId: "coldWaterBasin",
      questionId: "cwb_grade_to_curb_height",
    },
    {
      fieldName: "baySizeLength",
      componentId: "generalInfo",
      questionId: "baySizeLength",
    },
    {
      fieldName: "baySizeWidth",
      componentId: "generalInfo",
      questionId: "baySizeWidth",
    },
    {
      fieldName: "baySizeHeight",
      componentId: "generalInfo",
      questionId: "baySizeHeight",
    },
    {
      fieldName: "structure_material",
      componentId: "structure",
      questionId: "structure_material",
    },
    {
      fieldName: "louver_exists",
      componentId: "louvers",
      questionId: [
        {
          id: "louver_exists_cf",
          towerType: "counterflow",
          options: [
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" },
          ],
        },
        {
          id: "louver_exists_xf",
          towerType: "crossflow",
          defaultValue: "yes",
          options: [{ value: "yes", label: "Yes" }],
          readOnly: true,
        },
      ],
      dependsOn: "tower_type",
      onChange: (value, currentTowerType) => {
        if (value === "no") {
          return {
            resetFields: [
              "louver_row_count",
              "louverBladeWidth",
              "louver_material",
            ],
          };
        }
      },
    },
    {
      fieldName: "louver_material",
      componentId: "louvers",
      questionId: [
        {
          id: "louver_material_cf",
          towerType: "counterflow",
        },
        {
          id: "louver_material_xf",
          towerType: "crossflow",
        },
      ],
    },
    {
      fieldName: "louver_row_count",
      componentId: "louvers",
      questionId: "louver_row_count",
    },
    {
      fieldName: "louver_blade_width",
      componentId: "louvers",
      questionId: [
        {
          id: "louver_blade_width_cf",
          towerType: "counterflow",
        },
        {
          id: "louver_blade_width_xf",
          towerType: "crossflow",
        },
      ],
    },
    {
      fieldName: "airInletsHeight",
      componentId: "generalInfo",
      questionId: "airInletHeight",
    },
    {
      fieldName: "casing_air_inlets",
      componentId: "casing",
      questionId: [
        {
          id: "casing_air_inlets_cf",
          towerType: "counterflow",
          options: [
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" },
          ],
        },
        {
          id: "casing_air_inlets_xf",
          towerType: "crossflow",
          hidden: true,
        },
      ],
      dependsOn: "tower_type",
      onChange: (value, currentTowerType) => {
        if (currentTowerType !== "counterflow") {
          return {
            resetFields: ["airInletsOnEndWalls"],
          };
        }
      },
    },
    {
      fieldName: "casing_material",
      componentId: "casing",
      questionId: [
        {
          id: "casing_material_cf",
          towerType: "counterflow",
          options: [
            { value: "frp", label: "FRP" },
            { value: "cement_board", label: "Cement Board" },
            { value: "other", label: "Other" },
          ],
        },
        {
          id: "casing_material_xf",
          towerType: "crossflow",
          options: [
            { value: "frp", label: "FRP" },
            { value: "cement_board", label: "Cement Board" },
            { value: "other", label: "Other" },
          ],
        },
      ],
    },
    {
      fieldName: "fill_type",
      componentId: "fill",
      questionId: [
        {
          id: "fill_type_cf",
          towerType: "counterflow",
          options: [
            { value: "film_fill", label: "Film Fill" },
            { value: "modular_splash", label: "Modular Splash" },
            { value: "splash_fill", label: "Splash Fill" },
            { value: "other", label: "Other" },
          ],
        },
        {
          id: "fill_type_xf",
          towerType: "crossflow",
          options: [
            {
              value: "splash",
              label: "Splash",
              subQuestions: {
                text: "What is the Fill Orientation to Airflow?",
                type: "dropdown",
                options: [
                  { value: "Parallel", label: "Parallel" },
                  { value: "Perpendicular", label: "Perpendicular" },
                ],
              },
            },
            { value: "film", label: "Film Fill" },
            { value: "wood_lath", label: "Wood Lath" },
            { value: "other", label: "Other" },
          ],
        },
      ],
      dependsOn: "tower_type",
      onChange: (value, currentTowerType) => {
        if (value === "other") {
          return {
            showField:
              currentTowerType === "crossflow"
                ? "fill_type_other_xf"
                : "fill_type_other_cf",
          };
        }
      },
    },
    {
      fieldName: "dist_header_cl_cwb_curb",
      componentId: "distributionSystem",
      questionId: "dist_header_cl_cwb_curb",
    },
    {
      fieldName: "motor_hp",
      componentId: "mechanical",
      questionId: "motor_hp",
    },
    {
      fieldName: "fan_diameter",
      componentId: "mechanical",
      questionId: "fan_diameter",
      options: [
        { value: "10", label: "10" },
        { value: "12", label: "12" },
        { value: "14", label: "14" },
        { value: "16", label: "16" },
        { value: "18", label: "18" },
        { value: "20", label: "20" },
        { value: "22", label: "22" },
        { value: "24", label: "24" },
        { value: "26", label: "26" },
        { value: "28", label: "28" },
        { value: "30", label: "30" },
        { value: "32", label: "32" },
        { value: "33", label: "33" },
        { value: "10m", label: "10m" },
        { value: "34", label: "34" },
        { value: "36", label: "36" },
        { value: "40", label: "40" },
        {
          value: "other",
          label: "Other",
          subQuestions: {
            id: "fanstack_diameter_other",
            text: "Specify the Fanstack Diameter",
            type: "textarea",
          },
        },
      ],
    },
    {
      fieldName: "fanstack_height",
      componentId: "fanstack",
      questionId: "fanstack_height",
    },
    {
      fieldName: "partition_walls",
      componentId: "partitionwall",
      questionId: [
        {
          id: "partitionwall_type_cf",
          towerType: "counterflow",
        },
        {
          id: "partitionwall_type_xf",
          towerType: "crossflow",
        },
      ],
    },
    {
      fieldName: "partitionwall_material",
      componentId: "partitionwall",
      questionId: "partitionwall_material",
    },
    {
      fieldName: "partitionwall_frp_type",
      componentId: "partitionwall",
      questionId: "partitionwall_frp_type",
    },
    {
      fieldName: "partitionwall_wood_type",
      componentId: "partitionwall",
      questionId: "partitionwall_wood_type",
    },
    {
      fieldName: "partitionwall_quantity",
      componentId: "partitionwall",
      questionId: "partitionwall_quantity",
    },
    {
      fieldName: "partitionwall_between_cells",
      componentId: "partitionwall",
      questionId: "partitionwall_between_cells",
    },
    {
      fieldName: "partitionwall_panels_both_sides",
      componentId: "partitionwall",
      questionId: "partitionwall_panels_both_sides",
    },
    {
      fieldName: "fire_walls",
      componentId: "firewall",
      questionId: "firewall_exists",
    },
    {
      fieldName: "firewall_material",
      componentId: "firewall",
      questionId: "firewall_material",
    },
    {
      fieldName: "firewall_frp_thickness",
      componentId: "firewall",
      questionId: "firewall_frp_thickness",
    },
    {
      fieldName: "firewall_cement_board_thickness",
      componentId: "firewall",
      questionId: "firewall_cement_board_thickness",
    },
    {
      fieldName: "firewall_between_cells",
      componentId: "firewall",
      questionId: "firewall_between_cells",
    },
    {
      fieldName: "firewall_quantity",
      componentId: "firewall",
      questionId: "firewall_quantity",
    },
    {
      fieldName: "stairway_count",
      componentId: "stairway",
      questionId: "stairway_count",
    },
    {
      fieldName: "ladder_count",
      componentId: "ladders",
      questionId: "ladder_count",
    },
    {
      fieldName: "tower_notes",
      componentId: "notes",
      questionId: "tower_notes",
    },
  ],
};
